import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
} from '@mui/material';
import { ListaAcessoComponentes } from './componentes/ListaAcessoComponentes';
import { EnumContainerTipo } from '../../../../../shared/enums';



type AcessoComponente = {
  id: string;
  nome: string;
  acessoComponentes?: Array<{
    id: string;
    componente: string;
  }>;
  acessoSistemas?: Array<{
    id: string;
    sistema: string;
    sistemaId?: string;
  }>;
};

type Props = {
  open: boolean;
  onClose: () => void;
  onSave?: (values: any) => void;
  availableContainers?: { id: string; tipo: string }[]; // Mantém compatibilidade, mas será ignorado
  initialValues?: {
    id?: string;
    nome?: string;
    containerId?: string;
    acessoComponentes?: AcessoComponente[];
  };
};

export const ModalCamadas: React.FC<Props> = ({
  open,
  onClose,
  onSave,
  availableContainers,
  initialValues,
}) => {
  const [nome, setNome] = useState('');
  const [containerId, setContainerId] = useState('');
  const [acessoComponentes, setAcessoComponentes] = useState<
    AcessoComponente[]
  >([]);
  const [isValid, setIsValid] = useState(false);


  // Gera as opções a partir do EnumContainerTipo
  const containerOptions = Object.entries(EnumContainerTipo)
    .filter(([key, value]) => typeof value === 'number')
    .map(([key, value]) => ({ id: String(value), tipo: key }));

  useEffect(() => {
    if (open) {
      if (initialValues) {
        setNome(initialValues.nome || '');
        setContainerId(initialValues.containerId || '');
        setAcessoComponentes(initialValues.acessoComponentes || []);
      } else {
        setNome('');
        setContainerId('');
        setAcessoComponentes([]);
      }
    }
  }, [open, initialValues]);

  useEffect(() => {
    const allFilled = Boolean(nome.trim() && containerId);
    setIsValid(allFilled);
  }, [nome, containerId]);

  useEffect(() => {
    if (!open) {
      // Limpar campos apenas quando o modal for fechado
      setNome('');
      setContainerId('');
      setAcessoComponentes([]);
    }
  }, [open]);

  const handleSave = () => {
    const values: any = {
      nome,
      containerId,
      acessoComponentes,
    };
    if (initialValues && initialValues.id) values.id = initialValues.id;
    if (onSave) onSave(values);
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        {initialValues?.id ? 'Editar Camada' : 'Nova Camada'}
      </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection="column" gap={3} sx={{ pt: 1 }}>
          <TextField
            fullWidth
            label="Nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            placeholder="Nome da camada"
            autoFocus
          />

          <FormControl fullWidth>
            <InputLabel id="container-label">Container</InputLabel>
            <Select
              labelId="container-label"
              id="container-select"
              value={containerId}
              label="Container"
              onChange={(e) => setContainerId(e.target.value as string)}
            >
              {containerOptions.map((container) => (
                <MenuItem key={container.id} value={container.id}>
                  {container.tipo}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box>
            <Box sx={{ mb: 2, fontWeight: 'medium' }}>
              Componentes de Acesso
            </Box>
            <ListaAcessoComponentes
              initialRows={acessoComponentes}
              onAcessoComponentesChange={setAcessoComponentes}
              currentCamadaId={initialValues?.id}
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={handleSave}
          color="primary"
          disabled={!isValid}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
